// extracted by mini-css-extract-plugin
module.exports = {"chip":"BrandChip_chip__OOClr","supplierLink":"BrandChip_supplierLink__IRelv","logoImg":"BrandChip_logoImg__KbI0P"};